import { render, staticRenderFns } from "./QuestionsAndAnswers.vue?vue&type=template&id=2b2842c4&scoped=true&"
import script from "./QuestionsAndAnswers.vue?vue&type=script&lang=js&"
export * from "./QuestionsAndAnswers.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsAndAnswers.css?vue&type=style&index=0&id=2b2842c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2842c4",
  null
  
)

export default component.exports